import { render, staticRenderFns } from "./PowerPage.vue?vue&type=template&id=04e3c31e&scoped=true"
import script from "./PowerPage.vue?vue&type=script&lang=js"
export * from "./PowerPage.vue?vue&type=script&lang=js"
import style0 from "./PowerPage.vue?vue&type=style&index=0&id=04e3c31e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e3c31e",
  null
  
)

export default component.exports